import { AuthorizationStatusView, NotificationStatusView } from 'connections-embed-lib';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { Ribbon } from 'foundations-components/transitional/components/Ribbon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { formatInstalls } from 'marketplace-ui-common/utils/installs';
import { useGetAppStatuses } from 'connections-embed-lib/hooks/useGetAppStatus';
import { renderCardButtons } from './internal/CardButtons';
import { ListingIcon } from './internal/ListingIcon';
import { MarketplaceCardBase } from './internal/MarketplaceCardBase';
import { MarketplaceCardClickable } from './internal/MarketplaceCardClickable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function MarketplaceCardSmall({
  buttons,
  listing,
  onClick,
  tracker,
  trackingProps,
  transparent
}) {
  const product = listing.products[0];
  const {
    data: statusList,
    loading,
    refetch: refetchAppStatuses
  } = useGetAppStatuses({
    appId: product.installed && product.sourceId ? Number(product.sourceId) : undefined
  });
  const cardButtons = renderCardButtons({
    buttons,
    listing,
    onConnectionComplete: refetchAppStatuses
  });
  const content = /*#__PURE__*/_jsx(MarketplaceCardBase, {
    componentType: "MarketplaceCardSmall",
    listing: listing,
    tracker: tracker,
    trackingProps: trackingProps,
    children: /*#__PURE__*/_jsxs(Flex, {
      children: [/*#__PURE__*/_jsxs(MarketplaceCardClickable, {
        listing: listing,
        componentType: "MarketplaceCardSmall",
        alignItems: "start",
        display: "flex",
        flexGrow: 1,
        gap: "400",
        minInlineSize: "0",
        onClick: onClick,
        paddingBlock: "300",
        paddingInline: "400",
        position: "relative",
        trackingProps: trackingProps,
        children: [listing.betaStage && /*#__PURE__*/_jsx(Ribbon, {
          position: "left",
          use: "beta",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-embed.card.beta"
          })
        }), product.installed && /*#__PURE__*/_jsx(NotificationStatusView, {
          statusesList: statusList,
          type: "ribbon"
        }), /*#__PURE__*/_jsx(ListingIcon, {
          listing: listing,
          iconSize: 40
        }), /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          flexGrow: 1,
          gap: "50",
          minInlineSize: "0",
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h4",
            typography: "heading-100",
            truncate: {
              lineClamp: 1
            },
            children: listing.listingName
          }), product.installed && /*#__PURE__*/_jsx(View, {
            marginBlock: "-200",
            children: /*#__PURE__*/_jsx(AuthorizationStatusView, {
              appId: Number(product === null || product === void 0 ? void 0 : product.sourceId) || 0,
              accountStatusesList: statusList,
              loading: loading,
              listingDetails: {
                listingId: listing.listingId,
                productType: product.productType
              },
              showInstalledStatus: true
            })
          }), !product.installed && (listing.companyName || listing.installCount !== undefined) && /*#__PURE__*/_jsxs(Text, {
            as: "small",
            color: "text-core-subtle",
            children: [listing.companyName && /*#__PURE__*/_jsx(Text, {
              as: "span",
              marginInlineEnd: "400",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplace-embed.card.providerName",
                options: {
                  providerName: listing.companyName
                }
              })
            }), listing.installCount !== undefined && /*#__PURE__*/_jsx(Text, {
              as: "span",
              display: "inline-block",
              whiteSpace: "nowrap",
              children: formatInstalls(listing.installCount)
            })]
          })]
        })]
      }), !!cardButtons.length && /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        flexShrink: 0,
        marginInlineEnd: "400",
        children: cardButtons
      })]
    })
  });
  if (transparent) return content;
  return /*#__PURE__*/_jsx(CardWrapper, {
    marginBlockEnd: "0",
    blockSize: "100%",
    children: content
  });
}